import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = (process.env.REACT_APP_API_BASE || '/api').replace(/["']/g, '').replace(/\/+$/, '');

export default function AdminCreateParent() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear messages when user types
    if (error) setError('');
    if (success) setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await fetch(`${API_BASE}/admin/parents`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to create parent account');

      setSuccess(`✅ Parent account for ${data.parent.first_name} ${data.parent.last_name} created successfully!`);
      
      // Reset form
      setFormData({ first_name: '', last_name: '', email: '', phone: '', password: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', padding: 30, background: '#fff', borderRadius: 8, border: '1px solid #ddd', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 25 }}>
        <h2 style={{ margin: 0, fontSize: 22 }}>👨‍👩‍👧 Create Parent Account</h2>
        <button 
          onClick={() => navigate('/admin/dashboard')} 
          style={{ padding: '8px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
        >
          ← Back to Dashboard
        </button>
      </div>

      {error && (
        <div style={{ padding: 12, background: '#f8d7da', color: '#721c24', borderRadius: 6, marginBottom: 20, border: '1px solid #f5c6cb', fontSize: 14 }}>
          ❌ {error}
        </div>
      )}
      
      {success && (
        <div style={{ padding: 12, background: '#d4edda', color: '#155724', borderRadius: 6, marginBottom: 20, border: '1px solid #c3e6cb', fontSize: 14 }}>
          {success}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginBottom: 15 }}>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14, color: '#333' }}>First Name *</label>
            <input 
              type="text" 
              name="first_name" 
              value={formData.first_name} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }} 
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14, color: '#333' }}>Last Name *</label>
            <input 
              type="text" 
              name="last_name" 
              value={formData.last_name} 
              onChange={handleChange} 
              required 
              style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }} 
            />
          </div>
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14, color: '#333' }}>Email Address *</label>
          <input 
            type="email" 
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            required 
            placeholder="parent@example.com"
            style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }} 
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14, color: '#333' }}>Phone Number (Optional)</label>
          <input 
            type="text" 
            name="phone" 
            value={formData.phone} 
            onChange={handleChange} 
            placeholder="+1 234 567 8900"
            style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }} 
          />
        </div>

        <div style={{ marginBottom: 25 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 14, color: '#333' }}>Password *</label>
          <input 
            type="password" 
            name="password" 
            value={formData.password} 
            onChange={handleChange} 
            required 
            minLength={6}
            style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', boxSizing: 'border-box', fontSize: 14 }} 
          />
          <span style={{ fontSize: 12, color: '#666', marginTop: 4, display: 'block' }}>Minimum 6 characters required</span>
        </div>

        <button 
          type="submit" 
          disabled={loading} 
          style={{ 
            width: '100%', 
            padding: 12, 
            background: loading ? '#ccc' : '#28a745', 
            color: '#fff', 
            border: 'none', 
            borderRadius: 6, 
            cursor: loading ? 'not-allowed' : 'pointer', 
            fontSize: 16, 
            fontWeight: 600,
            transition: 'background 0.2s'
          }}
        >
          {loading ? '⏳ Creating Account...' : '✅ Create Parent Account'}
        </button>
      </form>
    </div>
  );
}